angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaLifeClientEditModalCtrl', ['$scope', function($scope) {
    $scope.helper.init();
    $scope.tplData = $scope.helper.tplData;
    $scope.modalData = $scope.helper.modalData;
    $scope.showElements = _.get($scope.helper, 'tplData.personEditForm.showElements');
    $scope.onChangeSubjectType = $scope.helper.onChangeSubjectType;
    $scope.onChooseOtherClient = $scope.helper.onChooseOtherClient;
  }]);
